<template>
  <div
    class="container-fluid"
    style="
      position: absolute;
      min-width: 100%;
      min-height: 100%;
      max-width: 100%;
      display: flex;
      align-items: center;
    "
  >
    <!--bg-maintenance-image-->

    <QrCode
      ref="QrCode"
      :name="'QrCode'"
      @onQr="getQRSerial"
      :manual="false"
      :photo="camMode"
      @onPhoto="getCamRes"
    />
    <modalImg ref="imgzoomC" :name="'modalImg'" :arrImg="modalArr" />

    <div class="col-md-6 offset-md-3 col-xs-12 pt-1">
      <div class="card border-grey border-lighten-3 px-1 py-1 box-shadow-3">
        <div class="card-block text-xs-center">
          <ul class="nav navbar-nav float-xs-right">
            <li class="dropdown dropdown-language nav-item">
              <a
                id="dropdown-flag"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="btn dropdown-toggle nav-link"
              >
                <i
                  ref="lang_btn"
                  class="flag-icon"
                  :class="$i18n.tc('lang.logo', $i18n.locale)"
                ></i>
                <span class="selected-language">
                  {{ $i18n.tc("lang.title", $i18n.locale) }}</span
                >
              </a>

              <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                <a
                  class="dropdown-item"
                  :id="lang"
                  v-for="(lang, index) in listLanguages"
                  :key="index"
                  @click="changeLanguage(lang)"
                >
                  <i
                    class="flag-icon"
                    :class="$i18n.getLocaleMessage(lang).lang.logo"
                  ></i>
                  {{ $i18n.getLocaleMessage(lang).lang.title }}
                </a>
              </div>
            </li>
          </ul>

          <span class="card-title text-xs-center">
            <a @click="openURL('https://modern-expo.eu')"
              ><img
                src="../assets/pictures/me_logo.png"
                class="img-fluid mx-auto d-block pt-2"
                width="250"
                alt="logo"
            /></a>
          </span>
        </div>
        <div class="card-block">
          <div class="row">
            <form class="form">
              <h4 class="form-section">
                <i class="icon-plus2"></i> {{ $t("problem.titles.add") }}
              </h4>
            </form>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-0">
                <h5>{{ $t("tasks.eqMethod.title") }}</h5>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="row mb-1">
                <div class="col-md-10">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="showModalQR()"
                        data-html="true"
                        :title="$t('equipm.hint.scanQr')"
                      >
                        <i class="icon-qrcode"></i>
                      </button>
                    </div>
                    <input
                      class="form-control border-primary"
                      type="text"
                      :placeholder="$t('equipm.table.serNumber')"
                      :class="{
                        'border-danger': $v.dataProblem.serials.$error,
                      }"
                      id="serial_enter"
                      v-model="dataProblem.serial"
                      @change="addSerial()"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-warning btn-round"
                        @click="addSerial()"
                      >
                        <i style="color: #ffffff" class="icon-plus2"></i>
                        {{ $t("tasks.buttons.addSerial") }}
                      </button>
                    </div>
                  </div>
                  <span
                    style="color: red"
                    class="d-flex"
                    v-if="$v.dataProblem.serials.$error"
                    >{{ $t("tasks.errors.entrSerial") }}</span
                  >
                </div>
                <div class="row pl-1 pr-1" v-if="lenSerials > 0">
                  <div class="col-md-12 mt-1">
                    <div class="form-group mb-0">
                      <button
                        type="button"
                        class="btn btn-danger btn-round"
                        @click="dataProblem.serials = []"
                        v-if="lenSerials > 1"
                      >
                        <i class="icon-bin"></i>
                        {{ $t("tasks.buttons.remove") }}
                      </button>
                      <span
                        v-for="(serial, index) in dataProblem.serials"
                        :key="index"
                        class="btn tag-default btn-warning"
                        style="margin: 0.2rem"
                      >
                        {{ serial }}
                        <a v-on:click="dataProblem.serials.splice(index, 1)"
                          ><i class="icon-bin"></i
                        ></a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-1" v-if="dataProblem.checks.length > 0">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <h5>{{ $t("problem.table.probl_categ") }}</h5>
                  </div>
                </div>

                <div
                  class="col-md-6"
                  v-for="(gr, ind) in dataProblem.checks"
                  :key="ind"
                >
                  <div
                    v-for="(ch, index) in gr"
                    :key="index"
                    class="hand"
                    @click="ch.checked = !ch.checked"
                    style="margin: 10px 5px 10px 5px"
                  >
                    <i
                      :class="[
                        ch.checked
                          ? 'icon-checkbox-checked'
                          : 'icon-checkbox-unchecked',
                      ]"
                      style="vertical-align: middle"
                    ></i>
                    <i
                      style="vertical-align: middle; margin-left: 5px"
                      class="font-large-1"
                      :class="ch.class"
                    ></i>
                    <span
                      style="
                        vertical-align: middle;
                        font-size: 1.3em;
                        max-width: 80%;
                        margin-left: 5px;
                      "
                    >
                      {{ $t(ch.title) }}</span
                    >
                  </div>
                </div>
              </div>

              <div class="form-group position-relative has-icon-left">
                <input
                  class="form-control border-primary"
                  type="text"
                  :class="{ 'border-danger': $v.dataProblem.persName.$error }"
                  :placeholder="$t('registr.lbl.pib')"
                  id="persName"
                  v-model.trim="$v.dataProblem.persName.$model"
                />
                <div class="form-control-position">
                  <i class="icon-user"></i>
                </div>
                <span v-if="$v.dataProblem.persName.$error" style="color: red">
                  <span
                    class="d-flex"
                    v-if="!$v.dataProblem.persName.required"
                    >{{ $t("errors.required") }}</span
                  >
                  <span class="d-flex" v-if="!$v.dataProblem.persName.minLength"
                    >{{ $t("errors.minLength") }}
                    {{ $v.dataProblem.persName.$params.minLength.min }}</span
                  >
                </span>
              </div>

              <div class="form-group position-relative has-icon-left">
                <input
                  class="form-control border-primary"
                  type="text"
                  :class="{ 'border-danger': $v.dataProblem.phone.$error }"
                  :placeholder="$t('users.table.phone')"
                  id="phone"
                  v-model.trim="$v.dataProblem.phone.$model"
                />
                <div class="form-control-position">
                  <i class="icon-phone"></i>
                </div>
                <span v-if="$v.dataProblem.phone.$error" style="color: red">
                  <span class="d-flex" v-if="!$v.dataProblem.phone.required">{{
                    $t("errors.required")
                  }}</span>
                  <span class="d-flex" v-if="!$v.dataProblem.phone.minLength"
                    >{{ $t("errors.minLength") }}
                    {{ $v.dataProblem.phone.$params.minLength.min }}</span
                  >
                </span>
              </div>

              <div class="form-group position-relative has-icon-left">
                <textarea
                  id="comment"
                  rows="3"
                  class="form-control border-primary"
                  name="comment"
                  :class="{ 'border-danger': $v.dataProblem.comment.$error }"
                  :placeholder="$t('tasks.table.comment')"
                  v-model.trim="$v.dataProblem.comment.$model"
                ></textarea>
                <div class="form-control-position">
                  <i class="icon-file-text"></i>
                </div>
                <span v-if="$v.dataProblem.comment.$error" style="color: red">
                  <span
                    class="d-flex"
                    v-if="!$v.dataProblem.comment.required"
                    >{{ $t("errors.required") }}</span
                  >
                  <span class="d-flex" v-if="!$v.dataProblem.comment.minLength"
                    >{{ $t("errors.minLength") }}
                    {{ $v.dataProblem.comment.$params.minLength.min }}</span
                  >
                </span>
              </div>

              <div class="">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-images2"></i> {{ $t("tasks.table.images") }}
                  </h4>

                  <div class="form-group">
                    <input
                      type="file"
                      name="file"
                      id="file"
                      class="inputfile"
                      multiple="multiple"
                      accept="image/x-png,image/jpeg"
                      @change="onUploadImg"
                    />
                    <label id="file_loader" for="file">
                      <a class="btn btn-primary btn-min-width"
                        ><i class="icon-upload3"></i>
                        {{ $t("tasks.buttons.file") }}</a
                      >
                    </label>

                    <button
                      type="button"
                      class="btn btn-warning"
                      @click="
                        camMode = true;
                        showModalQR();
                      "
                      data-html="true"
                      :title="$t('equipm.hint.camera')"
                    >
                      <i style="color: #ffffff" class="icon-camera8"></i>
                      {{ $t("tasks.buttons.photo") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="
                        dataProblem.images = [];
                        dataProblem.images2 = [];
                      "
                      v-if="dataProblem.images.length > 0"
                    >
                      <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                    </button>
                  </div>

                  <div class="row">
                    <div
                      class="col-md-12"
                      style="display: flex; flex-wrap: wrap"
                    >
                      <span
                        style="color: red"
                        class="d-flex"
                        v-if="$v.dataProblem.images.$error"
                        >{{ $t("errors.filesEmpty") }}</span
                      >

                      <div
                        class="col-xs-3"
                        style="
                          padding: 0;
                          display: flex;
                          flex-direction: column;
                          align-content: center;
                          justify-content: center;
                          margin-bottom: 1em;
                        "
                        v-for="(image, index) in dataProblem.images"
                        :key="index"
                      >
                        <div class="card hand mb-0" style="margin-left: 5px">
                          <div class="w-100 h-100">
                            <i
                              class="icon-cross delete-image-icon"
                              @click="
                                dataProblem.images.splice(index, 1);
                                dataProblem.images2.splice(index, 1);
                              "
                              data-html="true"
                              :title="$t('tasks.hint.delImg')"
                            ></i>
                            <img
                              v-bind:src="image.data"
                              style="max-width: 100%; max-height: 100%"
                              @click="expandDiv(dataProblem.images, index)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <form class="form">
            <div class="form-actions right">
              <button
                type="button"
                class="btn btn-warning"
                @click="createProblem()"
              >
                <i style="color: #ffffff" class="icon-checkmark22"></i>
                {{ $t("problem.btns.create") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, sameAs, email } from "vuelidate/lib/validators";

export default {
  name: "Appeal",
  components: {},
  data() {
    return {
      filesLimit: 24,
      modalArr: [],

      camMode: false,

      dataProblem: {
        serial: null,
        serials: [],
        comment: null,
        coordinate: {
          latitude: null,
          longitude: null,
          accuracy: null,
        },
        address: null,
        persName: null,
        phone: null,
        images: [],
        images2: [],
        checks: [],
      },
      categories: [],
    };
  },
  validations: {
    dataProblem: {
      serials: { required, minLength: minLength(1), $each: { required } },
      comment: { required, minLength: minLength(4) },
      persName: { required, minLength: minLength(4) },
      phone: { required, minLength: minLength(4) },
      images: { required, minLength: minLength(1), $each: { required } },
    },
  },
  methods: {
    openURL(str) {
      window.open(str);
    },
    onUploadImg(e) {
      let tt = null;
      let _this = this;
      if (e.target.files.length > 0) {
        for (let i = 0; i < e.target.files.length; i++) {
          const element = e.target.files[i];
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = (e) => {
            var img = new Image();
            img.onload = function () {
              if (img.width > 1500) {
                //зжимання
                var w = img.width;
                var h = img.height;
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d"); // Создаем узел атрибута
                var anw = document.createAttribute("width");
                anw.nodeValue = w;
                var anh = document.createAttribute("height");
                anh.nodeValue = h;
                canvas.setAttributeNode(anw);
                canvas.setAttributeNode(anh);
                ctx.drawImage(img, 0, 0, w, h);
                // Чем меньше значение .7, тем более размытым будет нарисованное изображение
                var base64Img = canvas.toDataURL("image/jpeg", 0.6);
                //зжимання

                tt = base64Img.split(",");
              } else {
                tt = img.src.split(",");
              }

              let err = false;
              if (_this.dataProblem.images.length < _this.filesLimit) {
                let name =
                  "newProblem_" + Math.floor(Math.random() * 4999) + ".png";
                _this.dataProblem.images.push({
                  name: name,
                  data: tt[0] + "," + tt[1],
                });
                _this.dataProblem.images2.push({ name: name, data: tt[1] });
              } else {
                err = true;
              }
              if (err) {
                _this.$notify({
                  group: "info",
                  title: "Warning",
                  text: "Ліміт файлів " + _this.filesLimit + 1,
                });
              }
            };
            img.src = e.target.result;
          };
        }
      }
    },
    getCamRes(dataCam) {
      this.camMode = false;
      if (this.isValid(dataCam)) {
        let name = "newProblem_" + Math.floor(Math.random() * 4999) + ".png";
        this.dataProblem.images.push({ name: name, data: dataCam });
        this.dataProblem.images2.push({
          name: name,
          data: dataCam.split(",")[1],
        });
      }
    },
    createProblem() {
      return;
      let errors = [];

      this.$v.dataProblem.serials.$touch();
      this.$v.dataProblem.comment.$touch();
      this.$v.dataProblem.persName.$touch();
      this.$v.dataProblem.phone.$touch();
      this.$v.dataProblem.images.$touch();

      if (
        !this.$v.dataProblem.serials.$error &&
        !this.$v.dataProblem.comment.$error &&
        !this.$v.dataProblem.persName.$error &&
        !this.$v.dataProblem.phone.$error &&
        !this.$v.dataProblem.images.$error
      ) {
        this.$v.dataProblem.serials.$reset();
        this.$v.dataProblem.comment.$reset();
        this.$v.dataProblem.persName.$reset();
        this.$v.dataProblem.phone.$reset();
        this.$v.dataProblem.images.$reset();

        let arrS = "";
        for (let i = 0; i < this.lenSerials; i++) {
          //arrS = arrS + this.$store.state.newTask.serials[i].serial + ',';
          arrS = arrS + this.dataProblem.serials[i] + ",";
        }
        arrS = arrS.slice(0, -1);

        let checks = [];
        //прохід по dataProblem.checks
        for (let i = 0; i < this.dataProblem.checks.length; i++) {
          for (let j = 0; j < this.dataProblem.checks[i].length; j++) {
            checks.push(this.dataProblem.checks[i][j].guid);
          }
        }

        let dataRequest = {
          serial: arrS,
          comment:
            this.dataProblem.persName +
            "," +
            this.dataProblem.phone +
            "," +
            this.dataProblem.comment,
          coordinate: this.dataProblem.coordinate,
          address: this.dataProblem.address,
          images: this.dataProblem.images,
          images2: this.dataProblem.images2,
          categories: checks,
        };
        this.makeQuery("/service/addProblem", {
          dataRequest: dataRequest,
          token: 0,
        })
          .then((result) => {
            this.showNotification(
              "custom-success",
              this.$t("titles.problem"),
              this.$t("problem.titles.add") + " " + result.problem_id
            );
            this.clearDataProbl();
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    getQRSerial(serial) {
      this.dataProblem.serial = serial;
      this.addSerial();
    },
    addSerial() {
      this.$v.dataProblem.serials.$touch();
      if (this.isValid(this.dataProblem.serial)) {
        let serr = this.checkPattSer(this.dataProblem.serial);
        if (serr) {
          this.dataProblem.serial = serr;
        } else {
          this.dataProblem.serial = null;
          return;
        }

        let ind_find = null;
        for (let i = 0; i < this.lenSerials; i++) {
          if (this.dataProblem.serial == this.dataProblem.serials[i]) {
            ind_find = i;
            break;
          }
        }
        if (ind_find == null) {
          this.dataProblem.serials.push(this.dataProblem.serial);
          this.$v.dataProblem.serials.$reset();
        }
        this.dataProblem.serial = null;
        if (
          this.lenSerials > 0 &&
          this.dataProblem.coordinate.latitude == null
        ) {
          this.getGPS()
            .then((result) => {
              this.dataProblem.coordinate.latitude = result.latitude;
              this.dataProblem.coordinate.longitude = result.longitude;
              this.dataProblem.coordinate.accuracy = result.accuracy;
            })
            .catch((err) => {
              this.showNotification("custom-error", "Geolocation", err.message);
            });
        }
      }
    },
    clearDataProbl() {
      this.dataProblem.serial = null;
      this.dataProblem.serials = [];
      this.dataProblem.comment = null;
      this.dataProblem.coordinate.latitude = null;
      this.dataProblem.coordinate.longitude = null;
      this.dataProblem.coordinate.accuracy = null;
      this.dataProblem.address = null;
      this.dataProblem.dateCreate = null;
      this.dataProblem.checks = [];
    },
    expandDiv(arr, ind) {
      if (arr[0].data != undefined) {
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push(arr[i].data);
        }
        arr = arr2;
      }

      $("#modalImg").modal("show");
      this.$refs.imgzoomC.onShow(ind, arr);
    },
    getListCategories(guidEq) {
      let categories = [];

      return new Promise((resolve, reject) => {
        let dataRequest = {
          guid: guidEq,
        };
        this.makeQuery("/service/getListProblemEquipment", {
          dataRequest: dataRequest,
          token: null,
        })
          .then((result) => {
            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.$store.state.categories.length; j++) {
                if (
                  parseFloat(result[i].icon) ==
                  this.$store.state.categories[j].id
                ) {
                  categories.push({
                    id: this.$store.state.categories[j].id,
                    guid: result[i].guid,
                    title: this.$store.state.categories[j].title,
                    class: this.$store.state.categories[j].class,
                    checked: false,
                  });
                  break;
                }
              }
            }
            return resolve(categories);
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      });
    },
  },
  computed: {
    listLanguages() {
      let arrLang = [];
      for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
        arrLang[
          this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id
        ] = this.$i18n.availableLocales[i];
      }
      return arrLang;
    },
    lenSerials() {
      return this.dataProblem.serials.length;
    },
  },
  components: {},
  mounted() {},
  beforeDestroy() {
    this.$root.$off();
  },
  watch: {
    lenSerials(value) {
      if (value == 1) {
        let dataRequest = {
          serial: this.dataProblem.serials[0],
          codeModel: null,
          userGuid: null,
        };
        //this.categories = [];
        this.dataProblem.checks = [];

        this.makeQuery("/service/productSerial", { dataRequest: dataRequest })
          .then((result) => {
            if (result.GUID != undefined) {
              //ме-21093576441
              this.dataProblem.address = result.Adress;
              /*this.getListCategories("60819896-2163-11ec-80ec-248a07729990")//result.GUID)
                            .then(result2 => {

                                if(result2.length > 0){
                                    this.dataProblem.checks.push([]);
                                    this.dataProblem.checks.push([]);

                                    for (let j = 0; j < result2.length; j++) {
                                        if(j % 2 == 0){ this.dataProblem.checks[0].push(result2[j]);} 
                                            else { this.dataProblem.checks[1].push(result2[j]); }
                                    }
                                }
                            });*/
            }
          })
          .catch((result) => {
            this.dataProblem.serials.splice(0, 1);
            this.showNotification("custom-error", "Error", result);
          });
      } else if (value == 0) {
        this.dataProblem.checks = [];
        this.dataProblem.address = null;
      }
    },
  },
  created() {
    //console.log(this.$route.params);
    this.clearDataProbl();
    if (this.$route.params.serial != null) {
      let ser = this.$route.params.serial;

      if (this.$route.params.address != null) {
        this.dataProblem.address = this.$route.params.address;
      }
      this.dataProblem.serial = ser;
      this.addSerial();
    } else {
      let df = document.location.search;
      if (df.length > 0 && this.$route.params.serial == undefined) {
        if (df.indexOf("se-") < 0) {
          df = "ме-" + df.split("-")[1];
        }
        this.dataProblem.serial = ser;
        this.addSerial();
      }
    }
  },
};
</script>

<style>
.col-xs-4 {
  padding: 0;
}
.border-danger {
  border: 3px solid #da4453 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Appeal.vue